import React, {useEffect, useRef} from "react";
import Gif from "../../../imgs/htmlAdvert3/F15-128659-Consilient-Mysimba-GP-Consult-Forum-Obesity.gif";

export const HTMLAdvert3 = ({hide, onClick}) => {
  const loopRef = useRef(null);

  const handleGifChange = () => {
    const frameDurations = [
      2000, // frame 0
      2000, // frame 1
      2000, // frame 2 (API)
    ];
    const apiLink = "https://www.consilienthealth.ie/mysimba/wp-content/uploads/sites/5/2025/12/MySimba-API-August-2025_IE-MYS-1646.pdf?utm_source=GP+Consult+Obesity+Template&utm_medium=MPU+on+GP+Consult+Obesity+template+&utm_campaign=Mysimba+awareness+campaign+obesity+template&utm_id=Gp+Consult+Obesity+template+&utm_term=GP+Consult+Obesity+Template&utm_content=GP+Consult+Obesity+Template";
    const defaultLink = "https://www.consilienthealth.ie/mysimba/?utm_source=GP+Consult+Obesity+Template&utm_medium=MPU+on+GP+Consult+Obesity+template+&utm_campaign=Mysimba+awareness+campaign+Obesity+template&utm_id=Gp+Consult+Obesity+template&utm_term=GP+Consult+Obesity+Template&utm_content=GP+Consult+Obesity+Template";
    const clickLayer = document.getElementById('clickLayer');

    let frame = 0;

    function loop() {
      if(frame === 2){
        clickLayer.href = apiLink;
      } else {
        clickLayer.href = defaultLink;
      }

      frame = (frame + 1) % frameDurations.length;
      loopRef.current = setTimeout(loop, frameDurations[frame]);
    }
    loop();
  };

  const handleGifLoad = () => {
    handleGifChange();
  };

  useEffect(() => {
    return () => {
      if (loopRef.current) clearTimeout(loopRef.current);
    };
  }, []);

  return !hide && (
    <div className="stage">
      <img src={Gif} alt="Mysimba Advert" id="banner" onLoad={handleGifLoad} />
      <a
        id="clickLayer"
        onClick={onClick}
        href="https://www.consilienthealth.ie/mysimba/?utm_source=GP+Consult+Obesity+Template&utm_medium=MPU+on+GP+Consult+Obesity+template+&utm_campaign=Mysimba+awareness+campaign+Obesity+template&utm_id=Gp+Consult+Obesity+template&utm_term=GP+Consult+Obesity+Template&utm_content=GP+Consult+Obesity+Template"
        target="_blank"></a>
    </div>
  );
};